import Cookies from 'js-cookie'

const AccessToken = 'ciftis_at'
const RefreshToken = 'ciftis_rt'
const UserName = 'ciftis_user_name'
const AccountName = 'ciftis_account_name'

const CsrfToken = 'csrfToken'
const domain = process.env.VUE_APP_COOKIE_DOMAIN

export function getToken() {
  const accessToken = Cookies.get(AccessToken)
  const refreshToken = Cookies.get(RefreshToken)
  if (accessToken && refreshToken) {
    return { accessToken, refreshToken }
  } else {
    // return null
    return {
      accessToken: 'mockSeEEkKCYuB8H',
      refreshToken: ''
    }
  }
}

export function setToken(token = {}) {
  const { accessToken, refreshToken, user, account } = token
  Cookies.set(AccessToken, accessToken, { domain })
  Cookies.set(RefreshToken, refreshToken, { domain })
  Cookies.set(UserName, user, { domain })
  Cookies.set(AccountName, account, { domain })
}

export function removeToken() {
  Cookies.remove(AccessToken, { domain })
  Cookies.remove(RefreshToken, { domain })
}

export function getCSRFToken() {
  return Cookies.get(CsrfToken)
}
